import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const AnalyticsLineChart = ({
  title,
  data,
  lines = [],
  yDomain,
  suffix = "",
}) => {
  const gradientId = (dataKey) =>
    `${title.replace(/\s+/g, "-").toLowerCase()}-${dataKey}-gradient`;

  return (
    <div className="rounded-lg bg-[#111827]/90 p-5 shadow-lg">
      <h2 className="mb-5 text-sm font-bold text-neutral-100">{title}</h2>

      <div className="h-[240px]">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={data}
            margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
          >
            <defs>
              {lines.map((line) => (
                <linearGradient
                  key={line.dataKey}
                  id={gradientId(line.dataKey)}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={line.stroke}
                    stopOpacity={0.35}
                  />
                  <stop
                    offset="95%"
                    stopColor={line.stroke}
                    stopOpacity={0.05}
                  />
                </linearGradient>
              ))}
            </defs>

            <CartesianGrid stroke="#263246" strokeDasharray="3 3" />

            <XAxis
              dataKey="date"
              tick={{ fill: "rgba(255,255,255,0.55)", fontSize: 11 }}
              axisLine={{ stroke: "#263246" }}
              tickLine={false}
            />

            <YAxis
              domain={yDomain}
              tick={{ fill: "rgba(255,255,255,0.55)", fontSize: 11 }}
              axisLine={{ stroke: "#263246" }}
              tickLine={false}
              tickFormatter={(value) => `${value}${suffix}`}
            />

            <Tooltip
              contentStyle={{
                backgroundColor: "#1B263A",
                border: "1px solid #263246",
                borderRadius: "8px",
                color: "#fff",
              }}
              labelStyle={{ color: "#fff" }}
              formatter={(value, name) => [`${value}${suffix}`, name]}
            />

            <Legend
              verticalAlign="bottom"
              iconType="circle"
              wrapperStyle={{
                color: "rgba(255,255,255,0.8)",
                fontSize: "12px",
              }}
            />

            {lines.map((line) => (
              <Area
                key={line.dataKey}
                type="monotone"
                dataKey={line.dataKey}
                name={line.name}
                stroke={line.stroke}
                strokeWidth={3}
                fill={`url(#${gradientId(line.dataKey)})`}
                fillOpacity={1}
                dot={false}
                activeDot={{
                  r: 5,
                  stroke: "#ffffff",
                  strokeWidth: 2,
                }}
              />
            ))}
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AnalyticsLineChart;
